var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-page-not-found',{staticClass:"va-page-not-found-simple"})
}
var staticRenderFns = []

export { render, staticRenderFns }